<script setup lang="ts">
import { onMounted } from "vue";
import WorkspaceOrderList from "./WorkspaceOrderList.vue";

const { t } = useI18n();
const { set: setTitle } = usePageTitle();

onMounted(() => {
  setTitle(t("workspaceOrder.title"));
});
</script>

<template>
  <WorkspaceOrderList />
</template>
